<template>
  <!-- Debugging Helper -->
  <!-- <pre class="overflow-y-scroll h-60">Bindings from Bindings List Component: {{ bindings }}</pre>
  <pre class="overflow-y-scroll h-60">props.modelValue from Bindings List Component: {{ props.modelValue }}</pre> -->
  
  
  <!-- Bindings List -->
  <div class="table-container">
    <table class="table" v-if="bindings.length">
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(binding, rowIndex) in bindings" :key="rowIndex">
          <td>
            {{ binding.humanReadableInfo?.implementationName }}
          </td>
          <td>
            {{ binding.humanReadableInfo?.instanceName }}
          </td>
          <td>
            <ul>
              <li v-for="(line, index) in binding.humanReadableInfo?.bindingOptionsSummaryLines" :key="index">
                {{ line }}
              </li>
            </ul>
          </td>
          <td>
            {{ binding.description }}
          </td>
          <td>
            <div class="flex gap-2">
              <BindingDialog mode="edit" v-model="bindings[rowIndex]" :key="rowIndex" />
              <OldThemeIcon name="delete" class="cursor-pointer" @click="removeBinding(rowIndex)" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pt-4" v-else>No Subscription Binding Added to this Subscription yet.</div>
  </div>
</template>

<script setup lang="ts">
import { ref, type PropType, watch } from 'vue';
import OldThemeIcon from '@/components/icons/OldThemeIcon.vue';
import BindingDialog from './BindingDialog.vue';

const props = defineProps({
  'modelValue': {
    type: Array as PropType<any[]>,
    default: () => [] as any[]
  }
});

const bindings = ref(props.modelValue);

const emit = defineEmits(['update:modelValue']);

const headers = [
  "Integration Service",
  "Integration Instance",
  "Binding Options",
  "Binding Description"
]

const removeBinding = (index: number) => {
  bindings.value.splice(index, 1);
  emit('update:modelValue', bindings.value);
};

watch([() => props.modelValue], () => {
  bindings.value = props.modelValue;
}, { deep: true });

watch([bindings], () => {
  emit('update:modelValue', bindings.value);
}, { deep: true });
</script>

<style lang="scss" scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.table {
  text-align: left;
  width: 1020px;
  margin-top: 2rem;

  td, th {
    padding-left: 3rem;
    vertical-align: top;
  
    &:first-child {
      padding-left: 0;
    }
  }

  tr:not(:last-child) td {
    border-bottom: 1px solid #e6e6e6;
  }
}

</style>